<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-1 bg-gradient-primary">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row">
              <div class="col-lg-12">
                <h1 class="display-3 text-white">
                  Pengurangan Pajak BPHTB
                  <span>Kabupaten Ketapang</span>
                </h1>
                <br />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <br />
    <br />
    <section class="section section-lg pt-lg-0">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="row row-grid">
              <card class="border-0" shadow body-classes="py-5">

                <b-row>
                  <b-col lg="6">
                    <b-input-group size="sm">
                      <b-form-input id="filter-input" v-model="filter" type="search"
                        placeholder="Ketik untuk mencari data"></b-form-input>

                      <b-input-group-append>
                        <base-button tag="a" class="mb-3 mb-sm-0" type="warning" textColor="white" icon="fa fa-reset"
                          :disabled="!filter" @click="filter = ''">Clear</base-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-col>
                  <b-col lg="6" class="my-1">
                    <div class="btn-wrapper float-right">
                      <base-button tag="a" class="mb-3 mb-sm-0" type="info" textColor="white" icon="fa fa-arrow-left"
                        @click="goback()">Kembali</base-button>
                      <base-button tag="a" class="mb-3 mb-sm-0" type="success" textColor="white" icon="fa fa-plus"
                        @click="newRegister()">Tambah</base-button>
                      <br />
                      <br />
                    </div>
                  </b-col>
                </b-row>

                <b-table :bordered="true" :small="true" :hover="true" :items="items" :fields="fields"
                  :head-variant="'light'" :busy.sync="isBusy" :per-page="perPage" :current-page="currentPage"
                  :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" 
                  :responsive="true" :filter="filter"
                  @filtered="onFiltered">
                  <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                      <pulse-loader :loading="isBusy" :color="'#d7f6e8'"></pulse-loader>
                      <strong>Loading...</strong>
                    </div>
                  </template>
                  <template #cell(status)="row">
                    {{
                      row.item.status_disetujui == 1
                      ? "Disetujui" :
                      row.item.status_disetujui == 2
                        ? "Ditolak"
                        : "Menunggu Persetujuan"

                    }}
                  </template>
                  <template #cell(actions)="row">
                    <div v-if="loading">
                      <i class="fa fa-spinner spin"></i>
                    </div>
                    <div v-else>
                      <div>
                        <button v-if="row.item.file_sk != null && row.item.status_disetujui == 1" size="sm"
                          variant="success" style="cursor: pointer" @click="downloadSK(row.item.file_sk)">
                          <i class="fa fa-print"></i> SK Penguranan
                        </button>
                      </div>
                      <button v-if="row.item.sts == '0' && (row.item.status_disetujui == 1 || row.item.status_disetujui == 2)" size="sm" variant="success"
                        style="cursor: pointer" @click="print(row.item)">
                        <i class="fa fa-print"></i> Kode Bayar
                      </button>
                      <div>
                        <button v-if="row.item.sts == '1' && (row.item.status_disetujui == 1 || row.item.status_disetujui == 2)" size="sm" variant="success"
                          style="cursor: pointer" @click="printSspd(row.item)">
                          <i class="fa fa-print"></i> SSPD
                        </button>
                      </div>
                      <div>
                        <button v-if="row.item.nama_sk != 'SSPD' && (row.item.status_disetujui == 1 || row.item.status_disetujui == 2)" size="sm"
                          variant="success" style="cursor: pointer" @click="skpd(row.item)">
                          <i class="fa fa-print"></i> {{ row.item.nama_sk }}
                        </button>
                      </div>
                    </div>
                  </template>
                </b-table>

                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"
                  aria-controls="my-table"></b-pagination>
              </card>
            </div>
          </div>
        </div>
      </div>
    </section>
    <esptpd ref="modal-e-sptpd" title="Form Pengurangan Pajak BPHTB" code="1101" @resetTable="getItems"></esptpd>
  </div>
</template>
<script>
import axios from "axios";
import {
  BTable,
  BTr,
  BTh,
  BPagination,
  BRow,
  BCol,
  BInputGroup,
  BFormGroup,
  BInputGroupAppend,
  BFormInput,
  BButton,
} from "bootstrap-vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import Esptpd from "./form_pengurangan";
export default {
  name: "walet",
  components: {
    BTable,
    BTr,
    BTh,
    PulseLoader,
    Esptpd,
    BPagination,
    BRow,
    BCol,
    BInputGroup,
    BFormGroup,
    BInputGroupAppend,
    BFormInput,
    BButton,
  },
  data() {
    return {
      filter: "",
      sortBy: "no_reg",
      sortDesc: true,
      perPage: 10,
      currentPage: 1,
      totalRows: 0,
      loading: false,
      isBusy: false,
      items: [],
      fields: [
        {
          key: "no_permohonan",
          sortable: false,
          label: "No.Pendaftaran",
          class: "text-center",
          sortByFormatted: false,
          thClass: "text-center",
        },
        {
          key: "tgl_pengajuran",
          sortable: false,
          label: "Tgl. Pengajuan",
          class: "text-center",
          thClass: "text-center",
        },
        {
          key: "tgl_disetujui",
          sortable: false,
          label: "Tgl. Disetujui",
          class: "text-center",
          thClass: "text-center",
        },
        {
          key: "pengurangan",
          sortable: false,
          label: "Pegnurangan (%)",
          class: "text-right",
          thClass: "text-center",
        },
        {
          key: "status",
          label: "Status",
        },
        { key: "actions", label: "Aksi" },
      ],
    };
  },
  mounted() {
    // Set the initial number of items
  },
  created() {
    this.getItems();
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    newRegister() {
      this.$refs["modal-e-sptpd"].showModal();
    },
    edit(items) {
      this.$refs["modal-e-sptpd"].showModal();
      this.$refs["modal-e-sptpd"].updateMode(items);
    },
    async getItems() {
      this.items = [];
      this.isBusy = true;
      try {
        let { data } = await axios.get(
          "/api/v1/pengurangan?kode_ppat=" +
          this.$store.state.auth.user.kode_ppat.toString()
        );
        this.items = data;
        this.totalRows = this.items.length;
      } catch (error) {
        // console.log(error);
      } finally {
        this.isBusy = false;
      }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    printSspd(items) {
      try {
        const me = this;
        this.loading = true;
        axios({
          url: "/api/bphtb/pendaftaran/sspd" + "?no_permohonan=" + items.no_permohonan,
          method: "GET",
          responseType: "blob",
        })
          .then((response) => {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute(
              "download",
              "Sspd_" +
              items.no_permohonan +
              ".pdf"
            );
            document.body.appendChild(fileLink);
            fileLink.click();
            this.loading = false;
          })
          .catch((e) => {
            // console.log(e);
            this.loading = false;
          });
      } catch (e) {
        // console.log(e);
        this.loading = false;
      }
    },
    print(items) {
      try {
        const me = this;
        this.loading = true;
        axios({
          url: "/api/bphtb/pendaftaran/kode-bayar" + "?no_permohonan=" + items.no_permohonan,
          method: "GET",
          responseType: "blob",
        })
          .then((response) => {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute(
              "download",
              "Kode_Bayar_" +
              items.no_permohonan +
              ".pdf"
            );
            document.body.appendChild(fileLink);
            fileLink.click();
            this.loading = false;
          })
          .catch((e) => {
            // console.log(e);
            this.loading = false;
          });
      } catch (e) {
        // console.log(e);
        this.loading = false;
      }
    },
    skpd(data) {
      const me = this;
      this.loading = true;
      axios({
        url: "/api/bphtb/penelitian/skp",
        method: "POST",
        responseType: "blob", // important
        data: { id: data.penelitian_id },
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        let name = data.nama_sk
        name += '_' + data.no_permohonan
        link.setAttribute(
          "download",
          name + ".pdf"
        ); //or any other extension
        document.body.appendChild(link);
        link.click();
        me.loading = false;
      });
    },
    downloadSK(name) {
      axios({
        url: "/api/v1/download_pdf?filename=" + name, //your url
        method: "GET",
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.setAttribute("download", name); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.section-shaped .shape.shape-skew+.shape-container {
  padding-top: 9rem;
  padding-bottom: 14rem;
}

.card {
  width: 100% !important;
}
</style>